import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getTemplateCauseImage } from '../template-model';
import { getTotalCollectedAmountByQuery } from '../../project/project-actions';
import OrganizationCtaCard from '../../organization/organization-show/organization-cta-card/OrganizationCtaCard';
import RoundedButtonLinkPrimary from '../../components/button/rounded-button-link-primary/RoundedButtonLinkPrimary';
import { PRIMARY_ORGANIZATION_COLOR, WHITE_ORGANIZATION_COLOR } from '../../organization/theme/OrganizationTheme';
import RoundedButtonLinkSecondary from '../../components/button/rounded-button-link-secondary/RoundedButtonLinkSecondary';
import styles from './organization-cta-template-embed-card.module.less';

export const OrganizationTemplateEmbedCard = ({
    className = '',
    templateId,
    title,
    description,
    img_url,
    birthday,
    dugnad,
    customLink,
    startProjectText,
    causeId,
}) => {
    const templateImage = useCallback(() => getTemplateCauseImage({ img_url, birthday, dugnad }), [img_url]);

    const [count, setCount] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            getTotalCollectedAmountByQuery({
                templateIds: [templateId],
            })
        ).then(({ count }) => {
            setCount(count);
        });
    }, [templateId]);

    return (
        <OrganizationCtaCard
            className={className}
            title={title}
            description={description}
            banner={templateImage()}
            projectCount={count}
            customLink={customLink}
            shortenTexts={true}
        >
            <div className={styles.buttons}>
                <>
                    <RoundedButtonLinkPrimary
                        className={PRIMARY_ORGANIZATION_COLOR}
                        to={`/cause/${causeId}`}
                        target={'_top'}
                    >
                        {startProjectText || 'Start en spleis for aksjonen'}
                    </RoundedButtonLinkPrimary>
                    <RoundedButtonLinkSecondary
                        className={WHITE_ORGANIZATION_COLOR}
                        to={`/cause/${causeId}`}
                        target={'_top'}
                    >
                        Gå til aksjonssiden
                    </RoundedButtonLinkSecondary>
                </>
            </div>
        </OrganizationCtaCard>
    );
};

export default OrganizationTemplateEmbedCard.js;
